import { createElement } from 'react';
import './address-list-item.scss';
import { convertChildren } from '../../utils/children-node-handle';
const AddressListItem = ({ children, phone, name, address, tag, selected, onClick = () => { }, onRemove, onEdit, ...otherProps }) => {
    const _otherProps = otherProps || {};
    return (createElement("div", { className: `address-list-item ${selected ? 'selected' : ''}`, ..._otherProps },
        createElement("div", { className: "address-list-item-circle", onClick: onClick }),
        createElement("div", { className: "address-list-item-content" },
            createElement("div", { className: "address-list-item-header" },
                convertChildren(children, 'name', {
                    children: [name],
                    className: 'address-list-item-name',
                }),
                convertChildren(children, 'tag', {
                    children: [tag],
                    className: 'address-list-item-tag',
                })),
            convertChildren(children, 'address', {
                children: [address],
                className: 'address-list-item-address',
            }),
            convertChildren(children, 'phone', {
                children: [phone],
                className: 'address-list-item-phone',
            }),
            createElement("div", { className: "address-list-item-actions" },
                createElement("button", { onClick: onRemove }, "REMOVE"),
                createElement("button", { onClick: onEdit }, "EDIT")))));
};
AddressListItem.displayName = 'AddressListItem';
export default AddressListItem;
